import BaseRepository from '@/core/standard/BaseRepository';
import {axiosInstance} from '@/setup/axios/AxiosConfig';
import {GenericMethod} from '@/core/Types/IRepository';

class CommandServices extends BaseRepository {
  public version = 'v1';
  public collection = 'commands';

  public invalidate(params: GenericMethod) {
    return this.request({...params, url: 'invalidate'});
  }

  // public getActiveTables(params: GenericMethod) {
  //   return this.request({...params, url: 'get_active_tables_by_zone'});
  // }

  public changeStatus(params: GenericMethod) {
    return this.request({...params, url: 'change_status'});
  }

  public retrieveReport(params: GenericMethod) {
    return this.request({...params, url: 'retrieve_report'});
  }

  public closeCommand(params: GenericMethod) {
    return this.request({...params, url: 'close_command'});
  }
  public closeCommandWithoutPayment(params: GenericMethod) {
    return this.request({...params, url: 'close_command_without_payment'});
  }

  public changeStatusByCommand(params: GenericMethod) {
    return this.request({...params, url: 'change_status_by_command'});
  }

  public checkCommand(params: GenericMethod) {
    return this.request({...params, url: 'check_command'});
  }

  public printAll(params: GenericMethod) {
    return this.request({...params, url: 'print_all'});
  }

  public printAllFromReport(params: GenericMethod) {
    return this.request({...params, url: 'print_all_from_report'});
  }

  public printSplit(params: GenericMethod) {
    return this.request({...params, url: 'print_split'});
  }

  public printDeliverySplit(params: GenericMethod) {
    return this.request({...params, url: 'print_split/delivery'});
  }

  public restorePayment(params: GenericMethod) {
    return this.request({...params, url: 'restore_payment'});
  }

  public getCommand(params: GenericMethod) {
    return this.request({...params, url: 'get_command'});
  }

  public sendTicketByEmailLocalAll(params: GenericMethod) {
    return this.request({...params, url: 'local_ticket_email'});
  }

  public sendTicketByEmailLocalSplit(params: GenericMethod) {
    return this.request({...params, url: 'local_ticket_email_split'});
  }

  public changeTable(params: GenericMethod) {
    return this.request({...params, url: 'change_table'});
  }
}

export default new CommandServices(axiosInstance);
